module.exports = __webpack_public_path__ + "img/can-do.7b8b4118.svg";